<template>
    <div>
        <div class="g-group">
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('pointSpace')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-point" /></div>
                            <div class="title">点位量算</div>
                        </div>
                    </div>
                    <div class="text">
                        坐标位置
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('lineSpace')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-dis-s" /></div>
                            <div class="title">空间距离</div>
                        </div>
                        <div @click="baseDraw('lineGround')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-dis-t" /></div>
                            <div class="title">贴地距离</div>
                        </div>
                    </div>
                    <div class="text">
                        距离量算
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('areaSpace')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-area-d" /></div>
                            <div class="title">空间面积</div>
                        </div>
                        <div @click="baseDraw('areaGround')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-area-t" /></div>
                            <div class="title">贴地面积</div>
                        </div>
                    </div>
                    <div class="text">
                        面积量算
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('heightSpace')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-height" /></div>
                            <div class="title">高度测量</div>
                        </div>
                    </div>
                    <div class="text">
                        高度量算
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('bearSpace')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-angle-f" /></div>
                            <div class="title">方位角测量</div>
                        </div>
                        <div @click="baseDraw('angleSpace')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-angle-r" /></div>
                            <div class="title">任意角测量</div>
                        </div>
                    </div>
                    <div class="text">
                        角度量算
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="clear()" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-clear" /></div>
                            <div class="title">清除</div>
                        </div>
                    </div>
                    <div class="text">
                        操作
                    </div>
                </div>
            </div>
        </div>
        <div class="g-msg">提示:鼠标左键取点，右键结束绘制。(鼠标左键双击测量结果即可删除选中测量结果)</div>
    </div>
</template>

<script>
import AnalysisManage from "@/utils/cesiumBD/analysis/AnalysisManage.js";
let analysisUti = undefined;

import PlotManage from "@/utils/cesiumBD/plot/PlotManage.js";
let plotUti = undefined;

export default {
    data() {
        return {

        };
    },

    mounted() {
        if (!plotUti) {
            plotUti = new PlotManage({});
        }

        plotUti.onDbclick(this.dbclick);
    },
    beforeDestroy() {
        plotUti.removeDbclick();
    },
    methods: {
        getPickEnity(pick) {
            if (Cesium.defined(pick) && (pick.id)) {
                return pick.id;
            }

            return null;
        },
        dbclick(evt) {
            let pick = viewer.scene.pick(evt.position);
            var entity = this.getPickEnity(pick);
            // entity.extTag = "BH_Feature";
            if (entity && entity.extTag && entity.extTag == "CL_Feature") {
                this.$confirm("是否删除该测量结果？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {

                        if (entity.attrPlot && entity.attrPlot["edit_keyPos"]) {
                            let entities = entity.attrPlot["edit_keyPos"];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_center"]) {
                            let entities = [entity.attrPlot["edit_center"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_rotation"]) {
                            let entities = [entity.attrPlot["edit_rotation"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }

                        if (entity.attrPlot && entity.attrPlot["edit_height"]) {
                            let entities = [entity.attrPlot["edit_height"]];
                            for (let i = 0; i < entities.length; i++) {
                                viewer.entities.remove(entities[i]);
                            }
                        }
                        viewer.entities.remove(entity); //自身

                    })
                    .catch(() => {
                        this.$message({
                            showClose: true,
                            type: "info",
                            message: "本次操作已取消！",
                            duration: 3 * 1000,
                        });
                    });

            }
        },
        baseDraw(type) {
            if (!analysisUti) {
                analysisUti = new AnalysisManage({
                    canEdit: true,
                });
            }
            analysisUti.start(type);
        },

        clear() {
            analysisUti && analysisUti.clear();
        },
    },
};
</script>

<style lang="scss" scoped>
.g-group {
    display: flex;
    flex-direction: row;
}

.g-msg {
    color: #E6A23C;
    font-size: 12px;
    padding: 4px 0 0 10px;
}

.f-group {
    color: #FFFFFF;
    font-size: 12px;
    flex: auto;

    .inner {
        border-right: 1px solid rgba(#FFFFFF, 0.2);

        .list {
            display: flex;

            .item {
                flex: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                cursor: pointer;

                .icon {
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .text {
            text-align: center;
            padding-top: 5px;
        }
    }
}
</style>